module.exports = __webpack_public_path__ + "static/media/dont2.d4571c3d.png";